module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/SavoryStuffing-9b49fca957f6219d74cb36ffa5b16e7e.webp";